var initializeBlockCarousel = function(block) {
	var $slick = jQuery('.slick', block);
	var count = $slick.children().length;
	var isTimeline = $slick.hasClass('timeline');
	var slidesToShow = isTimeline ? 3 : 1;
	var showDots = !isTimeline && count >= 2;

	var slickSettings = {
		slidesToShow: slidesToShow,
		slidesToScroll: slidesToShow,  // Typically you'd want this to match slidesToShow for timeline
		rows: 1,
		slidesPerRow: 1,
		dots: showDots,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: !isTimeline,  // Set infinite to false for timeline
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: []
	};

	if (isTimeline) {
		slickSettings.responsive = [
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: false  // Ensure infinite is false for responsive settings as well
				}
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false  // Ensure infinite is false for responsive settings as well
				}
			}
		];
	}

	$slick.not('.slick-initialized').slick(slickSettings);
};

// Initialize each block on front end
jQuery(document).ready(function() {
	jQuery('.wp-block-carousel').each(function() {
		initializeBlockCarousel(jQuery(this));
	});
});

// Initialize dynamic block preview in the editor
if (window.acf) {
	window.acf.addAction('render_block_preview/type=carousel', function($block) {
		initializeBlockCarousel($block);
	});
}
